<template>
    <div class="wrapper row mobilGrid">
        <div id="grid-template" v-on:scroll="scrl" :class="{vhminus200:page=='activity',vhminus200Organization:page=='organization'}">
                        
            <div v-for="(entry,index) in filteredData" :key="index" class="row py-2 m-0"  data-toggle="collapse" :data-target="'#collepse' + index" >

                <template v-for="col in columns" :key="col.prop">
                <div v-if="col && check(col['prop'])" class="spanWrapper col-12" v-bind:class="entry[col['prop']]['type']">
                    
                    <!--FOR DEALS-->
                    
                    <span v-if="col['prop']==='expectedDate'" :class="statu(entry[col['prop']]['val'])" class="dateInfo pull-left dealTag">{{statu(entry[col['prop']]['val'], "getMessage", $ml, $ml.current)}}</span>
                    
                    <span v-if="entry['rate']!==undefined && col['prop']==='expectedDate'" class="pull-right">
                        <img src="~/../assets/rate-normal.png" v-if="entry['rate']['val']==1"/>
                        <img src="~/../assets/rate-oncelikli.png" v-if="entry['rate']['val']==2">
                        <img src="~/../assets/rate-acil.png" v-if="entry['rate']['val']==3"/>
                    </span>

                    <span class="cursor-pointer hover-color-primary m-0 companyName" v-if="entry[col['prop']]['val']!==undefined && entry[col['prop']]['val']!==null && entry[col['prop']]['type']==='dealsOrgName'"> {{truncate(entry[col['prop']]['val'].name, 40)}}</span>
                    
                    <span v-if="entry[col['prop']]['type']==='dealsName'" class="f-12 bg-new-gray mt-1 pull-left dealTag">
                        {{truncate(entry[col['prop']]['val'], 40)}}
                    </span>
                    <span v-if="entry['cuid']!=undefined && entry[col['prop']]['type']==='dealsName'&&users.find(usr => usr._id==entry['cuid']['val']['$oid'])!=undefined" class="mt-1 pull-right bg-new-gray dealTag f-12 ml-1 cursor-pointer">
                        {{users.find(usr => usr._id==entry['cuid']['val']['$oid']).name[0]}}{{users.find(usr => usr._id==entry['cuid']['val']['$oid']).surName[0]}}
                    </span>
                    <label class="f-12 pb-0 mb-0 pull-right bg-new-gray dealTag mt-1" v-if="entry[col['prop']]['type']==='dealsName'">{{currencySymbol(entry['currency']['val'])}} {{formatPrice(entry['value']['val'])}}</label>

                    <!--FOR DEALS END-->

                    <!--FOR ACTIVITIES-->
                    <span class="bg-new-darkGray text-white dealTag mb-2 pull-left f-10" v-if="entry[col['prop']]['type']==='activityType'" >
                        {{activityType(entry[col['prop']]['val'], $ml)}}
                    </span>
                    <span class="border_transparent mb-2 pull-left ml-2 f-10 v-h-center" v-if="entry[col['prop']]['type']==='activityType' && entry['done']['val']!==''" >
                        <span v-if="entry['done']['val']==true">
                            {{$ml.get('COMPLETED')}}
                        </span>
                        <span v-else>
                            {{$ml.get('OPEN')}}
                        </span>
                    </span>
                    <span v-if="entry[col['prop']]['type']==='activityType' && entry['dueDate']['type']!==''" class="f-11 mt-1 pull-right light-darkGray-color" >
                        {{formatDate(entry['dueDate']['val']['$date'], "DD-MM-YYYY")}}
                    </span>
                    
                    <span v-if="entry[col['prop']]['type']==='organizations'" class="f-12" >
                        <template v-for="(organization, orgIdx) in entry[col['prop']]['val']" :key="orgIdx">
                            <span v-if="organization!=null" v-show="!entry[col['prop']]['isEditMode']">
                               {{truncate(organization['name'], 40)}}
                            </span>
                        </template>
                    </span>

                    <span v-if="entry[col['prop']]['type']==='subject'" class="f-11 mt-2 pull-left light-darkGray-color w-75 text-truncate pr-3 pt-1" >
                        {{entry[col['prop']]['val']}}
                    </span>
                    <span v-if="entry[col['prop']]['type']==='subject'" class="f-11 mt-2 pull-right light-darkGray-color w-25" >
                        <span class="bg-new-gray p-1 f-11 pull-right" v-if="entry['assignedTo']['val']!==undefined&&entry['assignedTo']['val']['$oid']!==''&&users.find(usr => usr._id['$oid']==entry['assignedTo']['val']['$oid'])!=undefined">
                            {{users.find(usr => usr._id['$oid']==entry['assignedTo']['val']['$oid']).name[0]}}{{users.find(usr => usr._id['$oid']==entry['assignedTo']['val']['$oid']).surName[0]}}
                        </span>
                        <i class="fa p-1 fa-chevron-right pull-right mx-0 border-radius-2"></i>
                        <span class="bg-new-gray p-1 f-11 pull-right border-radius-2" v-if="entry['assignor']['val']!==undefined&&entry['assignor']['val']['$oid']!==''&&users.find(usr => usr._id['$oid']==entry['assignor']['val']['$oid'])!=undefined">
                            {{users.find(usr => usr._id['$oid']==entry['assignor']['val']['$oid']).name[0]}}{{users.find(usr => usr._id['$oid']==entry['assignor']['val']['$oid']).surName[0]}}
                        </span>
                    </span>

                    <!--FOR ORGANIZATION-->
                    <span v-if="entry[col['prop']]['type']==='candidate'" class="bg-new-darkGray text-white dealTag mb-2 pull-left f-10">
                        {{candidateStatus(entry[col['prop']]['val'])}}
                    </span>
                    <span v-if="entry[col['prop']]['type']==='candidate'" class="pull-right f-10 px-1">
                        {{entry['city']['val']}}
                    </span>
                    
                    <span v-if="entry[col['prop']]['type']==='orgName'" class="f-12" > {{truncate(entry[col['prop']]['val'], 40)}}</span>

                    <span v-if="entry[col['prop']]['type']==='contacts'" class="f-11 pull-left mt-2 light-darkGray-color">
                        {{fullname(entry[col['prop']]['val']['0'])}}
                    </span>


                    <span v-if="entry[col['prop']]['type']==='emailAddresses' && entry[col['prop']]['val']!=undefined && entry[col['prop']]['val']!=''" class="f-11 pull-left">
                        <!-- <a :href="'mailto:'+entry[col['prop']]['val']['0']" class="light-darkGray-color"><i class="fa fa-envelope mr-1"></i>{{entry[col['prop']]['val']['0']}}</a> -->
                         <a class="light-darkGray-color"><i class="fa fa-envelope mr-1"></i>{{entry[col['prop']]['val']['0']}}</a>
                    </span>
                    <span v-if="entry[col['prop']]['type']==='emailAddresses' && entry['phoneNumbers']!=undefined && entry['phoneNumbers']['val']!=undefined && entry['phoneNumbers']['val']!=''" class="f-11 pull-right">
                        <!-- <a :href="'tel:'+entry['phoneNumbers']['val']['0']" class="light-darkGray-color"><i class="fa fa-phone mr-1 font-weight-bo ld"></i>{{entry['phoneNumbers']['val']['0']}}</a> -->
                        <a class="light-darkGray-color"><i class="fa fa-phone mr-1 font-weight-bo ld"></i>{{entry['phoneNumbers']['val']['0']}}</a>
                    </span>

                    <!--FOR CONTACT-->

                    <span v-if="entry[col['prop']]['type']==='contactName'" class="f-12 pull-left">
                        {{entry[col['prop']]['val']}} {{entry['sn']['val']}}
                    </span>
                    <span v-if="entry[col['prop']]['type']==='contactName'" class="f-12 pull-right">
                        {{entry['city']['val']}}
                    </span>

                    <span v-if="entry[col['prop']]['type']==='jobTitle'" class="f-12 pull-left">
                        {{entry[col['prop']]['val']}}
                    </span>

                    <span v-if="entry[col['prop']]['type']==='email' && entry[col['prop']]['val']!==null" class="f-11 pull-left mt-2">
                        <!-- <a :href="'mailto:'+entry[col['prop']]['val']['0']" v-if="Array.isArray(entry[col['prop']]['val'])" class="light-darkGray-color"><i class="fa fa-envelope mr-1"></i>{{entry[col['prop']]['val']['0']}}</a>
                        <a :href="'mailto:'+entry[col['prop']]['val']" v-else class="light-darkGray-color"><i class="fa fa-envelope mr-1"></i>{{entry[col['prop']]['val']}}</a> -->
                        <a v-if="Array.isArray(entry[col['prop']]['val'])" class="light-darkGray-color"><i class="fa fa-envelope mr-1"></i>{{entry[col['prop']]['val']['0']}}</a>
                        <a v-else class="light-darkGray-color"><i class="fa fa-envelope mr-1"></i>{{entry[col['prop']]['val']}}</a>
                    </span>

                    <span v-if="entry[col['prop']]['type']==='email' && entry['gsm']['val']!==null && entry['gsm']['val']!==''" class="f-11 pull-right mt-2">
                        <!-- <a :href="'tel:'+entry['gsm']['val']['0']" v-if="Array.isArray(entry['gsm']['val'])" class="light-darkGray-color"><i class="fa fa-phone mr-1"></i>{{entry['gsm']['val']['0']}}</a>
                        <a :href="'tel:'+entry['gsm']['val']" v-else class="light-darkGray-color"><i class="fa fa-phone mr-1 font-weight-bold"></i>{{entry['gsm']['val']}}</a> -->
                        <a v-if="Array.isArray(entry['gsm']['val'])" class="light-darkGray-color"><i class="fa fa-phone mr-1"></i>{{entry['gsm']['val']['0']}}</a>
                        <a v-else class="light-darkGray-color"><i class="fa fa-phone mr-1 font-weight-bold"></i>{{entry['gsm']['val']}}</a>
                    </span>

                    <!--FOR PRODUCT-->

                    <span v-if="entry[col['prop']]['type']==='brand' && entry[col['prop']]['val']!==null" class="border_transparent mb-2 pull-left f-10 v-h-center">{{entry[col['prop']]['val']}}</span>

                    <span v-if="entry[col['prop']]['type']==='brand' && entry['code']['val']!==null" class="pull-right h-20 f-10 v-h-center">{{entry['code']['val']}}</span>

                    <span v-if="entry[col['prop']]['type']==='productName'" class="f-12 pull-left">{{entry[col['prop']]['val']}}</span>

                    <span v-if="entry[col['prop']]['type']==='model'" class="f-12 pull-left py-1 v-h-center mt-1 light-darkGray-color">{{entry[col['prop']]['val']}}</span>
                    <span v-if="entry[col['prop']]['type']==='model' && entry['prices']!=='null' && entry['prices']['val'][0]['price']!==undefined && entry['prices']['val'][0]['price']!==null" class="f-12 pb-0 mb-0 pull-right bg-new-gray dealTag mt-1">{{currencySymbol(entry['prices']['val'][0]['currency'])}}{{entry['prices']['val'][0]['price']}}</span>

                </div>
                </template>

                <div class="collapse col-12 mt-3 mobilListCollepseBtn" :id="'collepse'+index" aria-expanded="false">
                    <div class="d-flex" v-if="page=='activity'">
                        <div class="doneBtn" @click="updateCell(entry,'done',true)" v-if="!entry['done']['val']">{{$ml.get('MARK_AS_COMPLETED')}}</div>
                        <div class="doneBtn" @click="updateCell(entry,'done',false)" v-else>{{$ml.get('MARK_AS_OPEN')}}</div>
                        <div class="update" data-toggle="modal" data-target="#add" @click="editLine(entry),modalMode='Düzenle'" :id="entry['_id']['val']['$oid']"> {{$ml.get('UPDATE')}}</div>
                        <div class="delete" @click="deleteThis(entry,page,index)" v-if="((ownerId==entry['cuid']['val']['$oid']&&$can('can_delete_activities'))||(ownerId!=entry['cuid']['val']['$oid']&&$can('can_delete_other_users_activities')))"><img src="~/../assets/delete.png"/></div>
                    </div>
                    <div class="d-flex" v-else-if="page=='contact'">
                        <div class="doneBtn" @click="contactCard(entry['_id']['val']['$oid'])">{{$ml.get('CONTACT_DETAILS')}}</div>
                        <div class="update" @click="editContact(entry['_id']['val']['$oid']),modalMode='Düzenle'" :id="entry['_id']['val']['$oid']" > {{$ml.get('UPDATE')}}</div>
                        <div class="delete" @click="deleteThis(entry,page,index)" v-if="((ownerId==entry['cuid']['val']['$oid']&&$can('can_delete_contacts'))||(ownerId!=entry['cuid']['val']['$oid']&&$can('can_delete_other_users_contacts')))"><img src="~/../assets/delete.png"/></div>
                    </div>
                    <div class="d-flex" v-else-if="page=='organization'">
                        <div class="doneBtn" @click="organizationCard(entry['_id']['val']['$oid'])">{{$ml.get('DETAILS_COMPANY')}}</div>
                        <div class="update" @click="editOrganization(entry['_id']['val']['$oid']),modalMode='Düzenle'" :id="entry['_id']['val']['$oid']"> {{$ml.get('UPDATE')}}</div>
                        <div class="delete" @click="deleteThis(entry,page,index)" v-if="((ownerId==entry['cuid']['val']['$oid']&&$can('can_delete_organizations'))||(ownerId!=entry['cuid']['val']['$oid']&&$can('can_delete_other_users_organizations')))"><img src="~/../assets/delete.png"/></div>
                    </div>
                    <div class="d-flex" v-else-if="page=='product'">
                        <div class="update" data-toggle="modal" data-target="#add" @click="editLine(entry),modalMode='Düzenle'" v-if="((ownerId==entry['cuid']['val']['$oid']&&$can('can_edit_products'))||(ownerId!=entry['cuid']['val']['$oid']&&$can('can_edit_other_users_products')))" :id="entry['_id']['val']['$oid']"> {{$ml.get('UPDATE')}}</div>
                        <div class="delete" @click="deleteThis(entry,page,index)" v-if="((ownerId==entry['cuid']['val']['$oid']&&$can('can_delete_products'))||(ownerId!=entry['cuid']['val']['$oid']&&$can('can_delete_other_users_products')))"><img src="~/../assets/delete.png"/></div>
                    </div>
                    <div class="d-flex" v-else-if="page=='opportunities'">
                        <div class="update" @click="dealsCard(entry['_id']['val']['$oid'])"> {{$ml.get('UPDATE')}}</div>
                        <div class="delete" @click="deleteThis(entry,page,index)" v-if="((ownerId==entry['cuid']['val']['$oid']&&$can('can_delete_deals'))||(ownerId!=entry['cuid']['val']['$oid']&&$can('can_delete_other_users_deals')))"><img src="~/../assets/delete.png"/></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import { mapActions } from 'vuex'
import { mapGetters} from 'vuex'
import axios from 'axios'
import _ from 'underscore'

import { Settings } from 'luxon'
import swal from 'sweetalert'
import Swal from 'sweetalert2'
import CountrySelect from '@/components/country-select'
import RegionSelect from '@/components/region-select'
import { activityType } from '@/services/resultTableFormatters'
import { formatPrice, fullname, truncate } from '@/services/gridFormatters'


export default {
    name: "grid",
    components:{
        CountrySelect,
        RegionSelect
    },
    /*
    props: {
        data: Array,
        columns: Array,
        cellUpdateUrl:String,
        filterGuide:String,
        page:String,
        user:Array
    },
    */
    props:["data","tableConfigVisible","columns","cellUpdateUrl","filterGuide","page","user","users","permissions"],
    data(){
        return {
            searchQuery: '',
            firstLetter:'',
            sortKey: '',
            sortOrders: {},
            editMode:false,
            checkedx:true,
            selectContact:'',
            selectOrganization:'',
            contactKeyword:'',
            dealKeyword:'',
            organizationKeyword:'',
            isHiddenOrganization:false,
            isHiddenContact:false,
            isHiddenDeal:false,
            items:[],
            contactId:"",
            dealId:"",
            organizationId:"",
            entrx:{},
            contactArray:[],
            keyList:['subject','name','n','sn'],
            countryList:[],
            checkedRows:[],
            checkAllRows:false

        }
    },
    computed: {
        ...mapState([
            'activityTypeList',
            'baseUrl',
            'isDoneList',
            'candidateList',
            'durationList',
            'cityList',
            'townList',
            'blockedList',
            'updateCellStatus'
        ]),
        ...mapGetters(['ownerId']),
        returnUpdateCell() {
             return this.$store.state.updateCellStatus
        },
        filteredData: function () {
            let sortKey = this.sortKey;// name
            let filterByLetter = this.firstLetter && this.firstLetter.toLowerCase();
            let order = this.sortOrders[sortKey] || 1;
            

            let data = this.data;
            let guideCol = this.filterGuide
            
            if(this.page=='activity'){
                
                let todaysActivities = 0

                const isToday = (someDate) => {
                    
                    
                    const theDay = new Date(someDate)
                    const today = new Date()
                    
                    return (theDay.toDateString() === today.toDateString())
                }


                for(var row in data){
                    for( var col in data[row]){
                        if(data[row][col]['val']!==null){
                            
                        
                            if(data[row]['done']['val']==false&&col=='dueDate'&&isToday(data[row][col]['val']['$date'])){
                                
                                todaysActivities=todaysActivities+1
                            }
                        }
                        
                    }
                }
                if(todaysActivities>0){
                    if(localStorage.loginCookie=="true"){
                        swal(this.activityMesaage(todaysActivities))
                    }
                    localStorage.loginCookie=!localStorage.loginCookie
                }
            }
            

            return data;
        }


    },
    methods: {
          activityType,
          formatPrice,
          fullname,
          truncate,
          formatDate(value, format){
            return this.$moment(value).format(format)
          },
          statu: function (value,message,ml,langg) {
              if(value===undefined || value===null){
                  if(message){
                    return ml.get('NO_ESTIMATED_CLOSING_DATE')
                  }
                  return "bg-date-not"
              }else{
                  value=value.$date
                  var dealDate=new Date(value)
                  var date = new Date()

  
                  var deal_day = dealDate.getDate();
                  var deal_month = dealDate.getMonth();
                  var deal_year = dealDate.getFullYear();
  
                  
                  var today = date.getDate();
                  var this_month = date.getMonth();
                  var this_year = date.getFullYear();
                  
                  var dealTime = new Date(deal_year,deal_month,deal_day);
                  var currentTime = new Date(this_year,this_month,today);

                  

                  if(message){
                    if(dealTime<currentTime){
                        return ml.get('DATE_PASSED')
                    }else if(dealTime>currentTime){
                        var howDay = Math.round((dealTime - currentTime) / (1000 * 60 * 60 * 24))
                        if(langg!='tr'){
                            return "Closes in "+ howDay +" days "
                        }else{
                            return howDay+" gün sonra kapanacak"
                        }
                    }else{
                        return ml.get('CLOSED_TODAY')
                    }
                  }else{
                    if(dealTime<currentTime){
                        return "bg-date-summary"
                    }else if(dealTime>currentTime){
                        var howDay = Math.round((dealTime - currentTime) / (1000 * 60 * 60 * 24))
                        if(howDay<=3){
                        return "bg-date-near-next"
                        }
                        return "bg-date-next"
                    }else{
                        return "bg-date-today-close"
                    }
                  }
            }
          },
        editOrganization(orgId){
            if(orgId!==null&&orgId!==undefined&&orgId!==''){
                this.$emit('editOrganization',orgId)
            }
        },
        editContact(contactId){
            if(contactId!==null&&contactId!==undefined&&contactId!==''){
                this.$emit('editContact',contactId)
            }
        },
        activityMesaage(count){
            if(localStorage.getItem('vueml-lang')=='tr'){
                var message="Bugün yapmanız gereken "+count+" aktivite var"
            }else{
                var message="You have "+count+" activity(ies) for today  "
            }
            return message
        },
        countryListSave(country,index){
            this.countryList[index]=country
        },
        getRates(rate){
            var rates={ 1:this.$ml.get('NORMAL'),2:this.$ml.get('PRIORITY'),3:this.$ml.get('URGENT') }
            return rates[rate]
        },
        getPriceVal(price){
            var prAray = []
            var prObj = {}
            prObj['price']=price['price']
            prObj['currency']=price['currency']
            prAray.push(prObj)
            return prAray
        },
        organizationCard(id){
            if(id!==""&&id!=null){
                //localStorage.orgId=id
                //this.updateOrgId(id)
                window.open('/organizationCard/'+id, '_blank');
            }
        },
        contactCard(id){
            if(id!==""){
                localStorage.contactId=id
                this.updateContactId(id)
                window.open('/contactCard/'+id, '_blank');
            }
        },
        dealsCard(id){
            if(id!==""){
                localStorage.dealId=id
                this.updateDealId(id)
                window.open('/dealCard/'+id, '_blank');
            }
        },
        ...mapActions([
            'updateCella',
            'updateOrgId',
            'updateContactId',
            'updateDealId',
            //'currencySymbol'
        ]),
        isPassiveOrg:function(entry){
            if(entry['status']==undefined || !entry['status']){
                return false
            }else{
                if(entry['status']['type']=='orgStatus'&&entry['status']['val']!=true){
                    return true
                }
            }
        
    
            
        },
        isProductPassive(entry){
            if(this.page=="product"){
                if(entry.status.val==null){
                    return false
                }else{
                    if(entry.status.val==true){
                        return false
                    }else{
                        return true
                    }
                }
            }
        },
        scrl: function(){
            const scrollYEmit = document.getElementById('grid-template').scrollTop
            const clientHeightEmit = document.getElementById('grid-template').clientHeight
            const scrollHeightEmit = document.getElementById('grid-template').scrollHeight
            var previousScrollPosition = clientHeightEmit
            var currentScrollPosition = scrollYEmit + clientHeightEmit

            if (currentScrollPosition>previousScrollPosition) {
                this.$emit('scrolled',scrollYEmit,clientHeightEmit,scrollHeightEmit)
            }
            
        },
        sortBy: function (key) {
        this.sortKey = key;
        if(this.sortOrders[key]==null){
            this.sortOrders[key]=1
        }
        this.sortOrders[key] = this.sortOrders[key] * -1
        var form={}
        form['sort']=this.sortKey 
        form['sortType']=this.sortOrders[key]
        this.$emit('sortedData',form)
        },
        candidateStatus: function (is) {
            
            if(is!==null){
                return is===true ? this.$ml.get('LEAD') : this.$ml.get('CUSTOMER')
            }else{
                return this.$ml.get('CUSTOMER')
            }
            
        },
        check:function(col){
            var cols = this.tableConfigVisible
            return cols.includes(col) && col!='_id' && col!='notes' && col!='x'
        },
        updateCell:function(model,col,val){
            let payload = {'model': model, 'col': col, 'val':val, 'url':this.cellUpdateUrl}
            this.$store.dispatch('updateCella', payload)
        },
        editLine(data){
            this.$store.dispatch('editLine', data)
            let statu=true
            this.$store.dispatch('editLineStatu', statu)
        },
        routerRequest(field,entry){
            this.entrx=entry
            
            if(field==="contact"){
                
                var orgId=''
                if(entry['orgId']['val'].length!==0){
                    
                    orgId=entry['orgId']['val'][0]['_id']['$oid']
                }
                if(this.selectContact!==this.contactKeyword){
                    this.quickContact(orgId) 
                    this.isHiddenOrganization=false
                    this.isHiddenDeal=false 
                }
                if(this.contactKeyword===""){
                    this.quickContact(orgId) 
                }
            }

            if(field==="organization"){
                
                if(this.selectOrganization!==this.organizationKeyword){
                    this.quickOrganization()
                    this.isHiddenContact=false
                    this.isHiddenDeal=false 
                }
                if(this.organizationKeyword===""){
                    this.quickOrganization() 
                }
            }

            if(field==="deal"){
                var contactId = '' 
                var orgId = ''
                if(entry['contactId']['val'].length!==0){
                    
                    contactId=entry['contactId']['val'][0]['_id']['$oid']
                } 
                if(entry['orgId']['val'].length!==0){
                    
                    orgId=entry['orgId']['val'][0]['_id']['$oid']
                }
                if(this.selectDeal!==this.dealKeyword){
                    this.quickDeal(contactId,orgId)
                    this.isHiddenOrganization=false
                    this.isHiddenContact=false 
                }
                if(this.dealKeyword===""){
                    this.quickDeal(contactId,orgId) 
                }
            }
        },
        quickDeal(contactId,orgId){
            axios({
                method:'POST',
                url:'/quickFilterDeal',
                baseURL: this.baseUrl,
                data: {
                    dealName:this.dealKeyword,
                    organizationId:orgId,
                    contactId:contactId
                },
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(!res.data.status){
                    this.$router.push('/logout')
                }
                if(res.data.status.code==0){
                    this.items=res.data.content.deals
                    this.isHiddenDeal= true
                }
            })
        },
        quickOrganization(){
            axios({
                method:'POST',
                url:'/quickFilterOrganization',
                baseURL: this.baseUrl,
                data: {
                    search:this.organizationKeyword,
                },
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(!res.data.status){
                    this.$router.push('/logout')
                }
                if(res.data.status.code==0){
                    this.items=res.data.content.organizations
                    this.isHiddenOrganization= true
                }
            })
        },
        quickContact(orgId){

            axios({
                method:'POST',
                url:'/quickFilterContact',
                baseURL: this.baseUrl,
                data: {
                    search:this.contactKeyword,
                    organizationId:orgId
                },
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(!res.data.status){
                    this.$router.push('/logout')
                }
                if(res.data.status.code==0){
                    this.items=res.data.content.contacts
                    if(this.items.length>0){
                        this.isHiddenContact= true
                    }
                }
            })
        },
        clear(){
            
            this.selectContact="",
            this.isHiddenOrganization=false,
            this.isHiddenContact=false,
            this.isHiddenDeal=false,
            this.items=[],
            this.contactId=""
        },
        setResult(result,type){
            if(type==="contact"){
                this.contactKeyword=""
                this.isHiddenContact= false
                this.contactId=result._id.$oid
                this.selectContact=result.n
            }

            if(type==="organization"){
                this.organizationKeyword=result.name
                this.isHiddenOrganization= false
                this.organizationId=result._id.$oid
                this.selectOrganization=result.name
            }

            if(type==="deal"){
                this.dealKeyword=result.title
                this.isHiddenDeal = false
                this.dealId=result._id.$oid
                this.selectDeal=result.title
            }

            this.entrx={}
        },
        getTownName(list,index){
            if(list!==undefined){
                return list[index]
            }
        },
        deleteThis(entry,from,index){
            if(from=='product'){
                var url = '/deleteProduct'
                var subj = this.$ml.get('DELETE_PRODUCT')
            }else if(from=='activity'){
                var url = '/deleteActivity'
                var subj = this.$ml.get('DELETE_ACTIVITY')
            }else if(from=='organization'){
                var url = '/deleteOrganization'
                var subj = this.$ml.get('DELETE_COMPANY')
            }else if(from=='contact'){
                var url = '/deleteContact'
                var subj = this.$ml.get('DELETE_CONTACT')
            }else if(from=="opportunities"){
                var url= "/deleteDeal"
                var subj = this.$ml.get('DELETE_DEAL')
            }
            Swal.fire({
                title: this.$ml.get('DELETE_RECORD'),
                text: this.$ml.get('DELETE_RECORD_CONFIRM'),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: '#d33',
                confirmButtonText: this.$ml.get('DELETE_RECORD_CONFIRM_BTN_TXT'),
                cancelButtonText: this.$ml.get('CANCEL'),
                customClass:{
                    icon:'custom-delete-warning',
                    cancelButton:'custom-delete-cancel-button'
                },
                reverseButtons:true
            })
            .then((result) => {
                if (result.isConfirmed) {
                    
                    axios({
                        method:'POST',
                        url:url,
                        baseURL: this.baseUrl,
                        data: {
                            objId:entry['_id']['val']['$oid']
                        },
                        withCredentials:true
                    }).then((res)=>{
                        return res
                    }).then((res)=>{
                        if(!res.data.status){
                            this.$router.push('/logout')
                        }
                        if(res.data.status.code==0){
                            this.filteredData.splice(index, 1)
                            let text = ""
                            if(from=='product'){
                                text=this.$ml.get('PRODUCT_DELETED')
                            }else if(from=='activity'){
                                text=this.$ml.get('ACTİVİTY_DELETED')
                            }else if(from=='organization'){
                                text=this.$ml.get('COMPANY_DELETED')
                            }else if(from=='contact'){
                                text=this.$ml.get('CONTACT_DELETED')
                            }else if(from=='opportunities'){
                                text=this.$ml.get('DEAL_DELETED')
                            }
                            
                            this.$notify({ 
                                group: 'foo',
                                type: 'success', 
                                title: this.$ml.get('SUCCESSFUL'),
                                text: text
                            })
                        }else{
                            this.$notify({ 
                                group: 'foo',
                                type: 'error', 
                                title: this.$ml.get('ERROR'),
                                text: res.data.status.desc
                            })
                        }
                    })
                    
                }
            })
        },
        trColor(index){
            if(index%2===0){
                return true
            }else{
                return false
            }
        }
    },
    created(){
        let sortOrders = {};
        this.columns.forEach(function (key) {
        sortOrders[key['prop']] = 1;
        })
        this.sortOrders = sortOrders;
        console.log("Currency.symbol(1)")
        console.log(this.currencySymbol(1))
    },
    watch: {
        checkAllRows(val){
            if(val){
                for(var entry in this.filteredData){
                    this.checkedRows.push(this.filteredData[entry]['_id']['val']['$oid'])
                }
                this.$emit('updateCheckedRows','allRowsChecked')
            }else{
                this.checkedRows=[]
                this.$emit('updateCheckedRows',this.checkedRows)
            }
        },
        checkedRows(){
            if(!this.checkAllRows){
                this.$emit('updateCheckedRows',this.checkedRows)
            }
        },
        returnUpdateCell(val){
            if(val){
                this.$emit('refleshData') 
            }
        },
        organizationKeyword: _.debounce(function(addr) {
            if(this.selectOrganization!==this.organizationKeyword && this.organizationKeyword.length!==0){
                this.quickOrganization()
                this.isHiddenContact=false
                this.isHiddenDeal=false
            }
            if(this.organizationKeyword===""){
                this.isHiddenOrganization= false
                this.organizationId=""
            } 
        }, 300),
        contactKeyword: _.debounce(function() {
            var entry = this.entrx
            var orgId=''
            if(entry['orgId']['val'].length!==0){
                orgId=entry['orgId']['val'][0]['_id']['$oid']
            }
            if(this.contactKeyword===""){
                this.isHiddenContact= false
                this.contactId=""
            } 
            if(this.selectContact!==this.contactKeyword && this.contactKeyword.length!==0){
                this.quickContact(orgId)
            }
        }, 300),
        dealKeyword: _.debounce(function() {
            var entry=this.entrx
            var contactId = '' 
            var orgId = ''
            if(entry['contactId']['val'].length!==0){
                
                contactId=entry['contactId']['val'][0]['_id']['$oid']
            } 
            if(entry['orgId']['val'].length!==0){
                
                orgId=entry['orgId']['val'][0]['_id']['$oid']
            }
            if(this.dealKeyword===""){
                this.isHiddenDeal=false
            } 
            if(this.selectDeal!==this.dealKeyword && this.dealKeyword.length!==0){
                this.quickDeal(contactId,orgId)
                this.isHiddenOrganization=false
                this.isHiddenContact=false 
            }
        }, 300)
    }
}
</script>
<style scoped>
     #grid-template > .table-body-wrapper {
        width: 100%;
    }

    #grid-template {
        width: 100%;
        overflow-x: auto;
        overflow-y: auto;
        height: calc(100vh - 148px);
    }
    #grid-template>div{
        border-bottom: 0.5px solid #AFC2D9;
    }
    @keyframes effect{
        0%{transform: scale(0);}
        25%{transform: scale(1.3);}
        75%{transform: scale(1.4);}
        100%{transform: scale(1);}
    }
    .mobilListCollepseBtn .delete {
    background: #FF0000;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    margin-left: 5px;
    }

    .mobilListCollepseBtn .update {
        width: calc(100% - 45px);
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(55, 103, 160, 0.1);
        border-radius: 4px;
        color: #3767A0;
    }
    .mobilListCollepseBtn .doneBtn+.update {
        width: calc(100% - 70%);
    }
    .mobilListCollepseBtn .doneBtn {
        background: rgba(25, 145, 235, 0.2);
        border-radius: 4px;
        color: #1991EB;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 5px;
        width: calc(100% - 35%);
    }   
    .mobilGrid .border_transparent {
        
        border: 0.5px solid #93959A;
        border-radius: 2px;
        height: 20px;
        padding: 0 4px;
    }
    
</style>
